import React, { Component, Fragment } from 'react';
import { observer, inject } from 'mobx-react';
import { withRouter } from "react-router";
import moment from 'moment';
import { Table, Pagination, Button, Select, Popconfirm } from 'antd';

@inject('goodsJobStore')
@observer
class GoodsJobList extends Component {
  state = {
    visiblePopconfirm: false
  };

  onPageChange = (pageIdx) => {
    // console.log('page:', page);
    this.props.goodsJobStore.disGoodsJobList(pageIdx);
  };

  onSearch = () => {
    this.props.goodsJobStore.disGoodsJobList(1);
  };

  onPressEnter = (e) => {
    if (e.key === 'Enter') {
      this.onSearch();
    }
  };

  render() {
    const {
      valCondition,
      onChangValue,
      goodsJobList,
      pageInfo,

      onViewMode,
      disGoodsJobList,
      disGoodsJobDetail,
      delGoodsJobList
    } = this.props.goodsJobStore;
    const { ceType, jobList } = this.props;
    const { visiblePopconfirm } = this.state;
    const columns = [
      { title: 'No', dataIndex: 'RNUM', width: '7%', align: 'center' },
      { title: '상품군', dataIndex: 'gjPGdCdName', width: '30%', align: 'center' },
      { title: '이용정보', dataIndex: 'gjJobNm', width: '33%', align: 'center',
        render: (item, record) => { return(
          <Fragment>
            {item} {record.gjGdCnt}개 {record.gjUseDate}년
          </Fragment>
        )}
      },
      { title: '등록일', dataIndex: 'gjMakeDate', width: '15%', align: 'center',
        render: (item, record) => { return(
          <Fragment>
            {moment(item).format('YYYY-MM-DD')}
          </Fragment>
        )}
      },
      { title: '삭제', dataIndex: '', width: '15%', align: 'center', 
        render: (item, record) => { return(
          <Popconfirm 
            title="삭제하시겠습니까?"
            onVisibleChange={(visible)=>this.setState({visiblePopconfirm: visible})}
            onConfirm={() => delGoodsJobList([record])}
            onClick={(e)=>e.stopPropagation()}
          >
            <Button>삭제</Button>
          </Popconfirm>
        )}
      },
    ];
    return (
      <Fragment>
        <div className="search-box mo_srch_box">
          <div className="search-content" style={{float:'left'}}>
            <span className="mo_srch">
              <span className="labal2">직무</span> 
              <Select
                style={{ width: 150, marginRight: '20px' }}
                value={valCondition.gjJobCd}
                onChange={(value)=>{
                  onChangValue('gjJobCd', value);
                  this.onSearch();
                }}
              >
                <Select.Option key={''}>전체</Select.Option>
                {jobList.map(item=>{
                  return(
                  <Select.Option key={item.jobCd}>{item.jobNm}</Select.Option>
                  )
                })}
              </Select>
            </span>
          </div>
          <div className="search-button">
            <Button type="primary" onClick={this.onSearch}>조회</Button>
          </div>
        </div>
        <div className="button-group">
          <Select
            style={{ width: 120 }}
            value={valCondition.recordCountPerPage}
            onChange={(value)=>disGoodsJobList(1, value)}
          >
            <Select.Option value={10}>10개 보기</Select.Option>
            <Select.Option value={20}>20개 보기</Select.Option>
            <Select.Option value={30}>30개 보기</Select.Option>
            <Select.Option value={40}>40개 보기</Select.Option>
          </Select>
          {(ceType === process.env.REACT_APP_TYPE_YUJIN) &&
            <div className="button-right">
              <ul>
                <li>
                  <Button 
                    type="primary"
                    onClick={()=>onViewMode('add')}
                  >추가</Button>
                </li>
              </ul>
            </div>
          }
        </div>
        <Table
          rowKey={(record)=>record.RNUM}
          columns={(ceType === process.env.REACT_APP_TYPE_YUJIN) 
                    ? columns : columns.slice(0, columns.length-1)} 
          dataSource={goodsJobList}
          pagination={false}
          onRow={(record, rowIndex) => {
            return {
              onClick: e => {
                e.preventDefault();
                visiblePopconfirm === false && disGoodsJobDetail(record);
              },
            };
          }}
        />
        <br />
        <div className="page_nav_ct">
          <Pagination
            showSizeChanger={false}
            current={pageInfo !== null ? pageInfo.pageIndex : 1}
            total={pageInfo !== null ? pageInfo.totalCnt : 0}
            pageSize={pageInfo !== null ? pageInfo.recordCountPerPage : 0}
            onChange={this.onPageChange}
          />
        </div>
      </Fragment>
    );
  }

}

export default withRouter(GoodsJobList);
